export default {
  weekdays: [
    {
      value: 1,
      name: 'Lundi',
    },
    {
      value: 2,
      name: 'Mardi',
    },
    {
      value: 3,
      name: 'Mercredi',
    },
    {
      value: 4,
      name: 'Jeudi',
    },
    {
      value: 5,
      name: 'Vendredi',
    },
    {
      value: 6,
      name: 'Samedi',
    },
    {
      value: 0,
      name: 'Dimanche',
    },
  ],
};
